/* eslint-disable */
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { CustomBreakpoints } from '../../enums/custom-breakpoints.enum';
import { Devices, getAllDevicesName } from '../../enums/devices.enum';
import { EffyBreakpoints } from '../../enums/effy-breakpoints.enum';
import { getAllImageSizeName, ImageSize } from '../../enums/image-size.enum';
import { ImagesService } from '../images-service/images.service';
import { DeviceManagerService, DeviceType } from './device-manager.service';

@Injectable({
  providedIn: 'root',
})
export class DeviceManagerBrowserService implements DeviceManagerService {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private currentDevice: Array<Devices> = [Devices.DESKTOP];
  breakpoints: { [key: string]: boolean };

  getCurrentDevice(): Observable<Array<Devices>> {
    return this.observeBreakpoint().pipe(
      map(result => {
        if (result.matches) {
          const currentImageSize = getAllImageSizeName().find(size => this.breakpointObserver.isMatched(CustomBreakpoints[size]));
          if (currentImageSize) {
            ImagesService.setCurrentImageSize(ImageSize[currentImageSize] as ImageSize);
          }
          this.currentDevice = getAllDevicesName()
            .filter(device => this.breakpointObserver.isMatched(EffyBreakpoints[device]))
            .map(currentDeviceName => Devices[currentDeviceName]);
          // to avoid image breakpoints
          if (this.currentDevice[0] === Devices.DESKTOP && !result.breakpoints[EffyBreakpoints.DESKTOP]) {
            this.currentDevice[0] = Devices.IPAD_PORTRAIT;
          }
          // save breakpointState
          this.breakpoints = result.breakpoints;
          return this.currentDevice;
        }
      })
    );
  }

  deviceType$(): Observable<DeviceType> {
    return this.getCurrentDevice().pipe(
      map(() => ({
        isMobile: this.isMobileOrMobileSE(),
        isDesktop: this.isDesktop(),
        bigViewPort: this.isDesktopOrIPAD_landscape(),
      })),
      distinctUntilChanged(
        (prev, curr) => prev.isMobile === curr.isMobile && prev.isDesktop === curr.isDesktop && prev.bigViewPort === curr.bigViewPort
      )
    );
  }

  isMobileOrMobileSE() {
    return [Devices.MOBILE_SE, Devices.MOBILE].indexOf(this.currentDevice[0]) > -1;
  }

  isDesktopOrIPAD_landscape() {
    return [Devices.DESKTOP, Devices.IPAD_LANDSCAPE].indexOf(this.currentDevice[0]) > -1;
  }

  isDesktop() {
    return [Devices.DESKTOP].indexOf(this.currentDevice[0]) > -1;
  }

  isAtLeastTabletWidth() {
    return this.breakpointObserver.observe(['(min-width: 678px)']).pipe(map(result => result.matches));
  }

  isLargeDesktop() {
    return this.breakpointObserver.observe(['(min-width: 1200px)']).pipe(map(result => result.matches));
  }

  isBigDesktop() {
    return this.breakpointObserver.observe(['(min-width: 992px)']).pipe(map(result => result.matches));
  }

  isMobileOrTablet(): Observable<boolean> {
    return this.breakpointObserver.observe(['(max-width: 1023px)']).pipe(map(result => result.matches));
  }

  private observeBreakpoint(): Observable<BreakpointState> {
    const devicesName = getAllDevicesName();
    const imageSizeName = getAllImageSizeName();

    const breakpoints = devicesName
      .concat(imageSizeName)
      .map(element => (imageSizeName.indexOf(element) > -1 ? CustomBreakpoints[element] : EffyBreakpoints[element]));
    return this.breakpointObserver.observe(breakpoints);
  }

  getFullUrlSSr() {
    return null;
  }

  getBaseUrlSSr() {
    return null;
  }

  getLocation(): string {
    return  window.location.origin;
  }
}
